import {ptracGet} from 'src/utilities/ptracApi'
import {OK} from 'http-status-codes'

let state = {}

export default {
  namespaced: true,
  state,
  getters: {
    byName(state) {
      return (name) => {
        return state[name] ? state[name] : null
      }
    }
  },
  mutations: {
    loadAll(state, config) {
      config.forEach((configVal) => {
        state[configVal.name] = configVal.value
      })
    }
  },
  actions: {
    async fetchAll({ state, commit }) {
      // only load once
      if (Object.keys(state).length > 0) {
        return
      }

      const response = await ptracGet('configs/findAll')
      if (OK === response.status) {
        commit('loadAll', response.data)
      }
    }
  }
}
